import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HisCoreSharedModule } from '../../../../../core/his-core-shared.module';
import { Dialog } from 'primeng/dialog';
import { LinkTarget } from '../../../../model/link-target';
import { CopyOpenLinkComponent } from './copy-open-link/copy-open-link.component';


@Component( {
    selector: 'his-bi-create-permalink',
    templateUrl: './create-permalink.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HisCoreSharedModule, Dialog, FormsModule, CopyOpenLinkComponent]
} )
export class CreatePermalinkComponent {
    @Input() reportName: string = '';
    @Input() storedReportId: number | null = null;
    @Input() label: string = '';

    applicationContext = '/a/';
    bidirectory = 'cs.bia.frontend';
    visible = false;
    permalink = '';
    linkTargetParam = '';

    linkTargets = Object.values( LinkTarget );
    selectedTarget: LinkTarget | null = null;

    showPermalinkDialog() {
        this.selectedTarget = LinkTarget.PARAM_TAB_TARGET;
        this.changeTarget( this.selectedTarget );
        this.permalink = this.createPermalink();
        this.visible = true;
    }

    createPermalink(): string {
        let url = this.cutAwayExistingQueryParams( document.URL );
        return url += this.bidirectory += this.linkTargetParam;
    }

    cutAwayExistingQueryParams( url: string ): string {
        let startGetParams = url.indexOf( this.applicationContext ) + this.applicationContext.length;
        return startGetParams > -1 ? url.substring( 0, startGetParams ) : url;
    }

    paramEncode( key: string, value: string ): string {
        return encodeURIComponent( key ) + '=' + encodeURIComponent( value ) + '&';
    }

    changeTarget( target: LinkTarget ) {
        this.permalink = this.permalink.replace( this.linkTargetParam, '' );
        this.selectedTarget = target;
        switch ( target ) {
            case LinkTarget.PARAM_TAB_TARGET: {
                this.linkTargetParam = target.route + this.storedReportId + '?';
                this.linkTargetParam += this.paramEncode( BiTab.SELECTION_TAB, 'true' );
                break;
            }
            case LinkTarget.DIRECT_RESULT_TARGET: {
                this.linkTargetParam = target.route + this.storedReportId + '?';
                this.linkTargetParam += this.paramEncode( BiTab.DIRECT_RESULT_TAB, 'true' );
                break;
            }
            case LinkTarget.READ_ONLY_TARGET: {
                this.linkTargetParam = target.route + this.storedReportId;
                break;
            }
        }
        this.permalink += this.linkTargetParam;
    }
}

export enum BiTab {
    DIRECT_RESULT_TAB = 'viewResultTab',
    SELECTION_TAB = 'viewSelectionTab',
}
